/* eslint-disable import/prefer-default-export */
export const theme = {
  palette: {
    background: '#F8F8F8',
    black: '#0E141B',
    red: '#E2565F',
    redOrange: '#EA6B4E',
    orange: '#F28147',
    yellowOrange: '#F9A84A',
    yellow: '#FDD04C',
    yellowGreen: '#96C066',
    green: '#30B189',
    blueGreen: '#3FA6AB',
    darkBlueGreen: '#1D8B90',
    blue: '#4B9CCF',
    darkBlue: '#1D6A92',
    blueViolet: '#6F82B5',
    darkBlueViolet: '#606A97',
    violet: '#8E689B',
    redViolet: '#B8607E',
    dcBlue: '#94bbe2',
    grey: '#949494',
    darkGrey: 'rgba(67, 67, 67, 1)',
  },
  cardShadow: '0px 2px 0px 0.5px rgba(14, 20, 27, 0.15)',
  iconShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  spacing: [15, 17, 24, 30, 35, 48, 60],
};
